import { SelectedFilters } from 'src/components/selected-filters/SelectedFilters';
import { useAppDispatch, useAppSelector } from 'src/store';

import { getDocumentTypeName } from './StudentDocuments.utils';
import { selectStudentDocumentsFilters } from './StudentSelectors';
import { setStudentDocumentsFilters } from './StudentSlice';

export const StudentSelectedFiltersDocuments = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectStudentDocumentsFilters);
  const getSelectedFilters = () => {
    const selectedFilters: Array<{
      type: 'documentType' | 'dateFrom' | 'dateTo';
      value: string;
      originalValue?: any;
    }> = [];

    if (filters.documentTypes && filters.documentTypes.length > 0) {
      selectedFilters.push(
        ...filters.documentTypes.map((type) => ({
          type: 'documentType' as const,
          value: getDocumentTypeName(type),
          originalValue: type,
        })),
      );
    }

    if (filters.from) {
      selectedFilters.push({
        type: 'dateFrom' as const,
        value: filters.from,
      });
    }

    if (filters.to) {
      selectedFilters.push({
        type: 'dateTo' as const,
        value: filters.to,
      });
    }

    return selectedFilters;
  };

  const handleRemoveFilter = (filterToRemove: { type: string; originalValue?: any }) => {
    if (filterToRemove.type === 'documentType') {
      const updatedDocumentTypes =
        filters.documentTypes?.filter((type) => type !== filterToRemove.originalValue) || [];
      dispatch(
        setStudentDocumentsFilters({
          ...filters,
          documentTypes: updatedDocumentTypes,
        }),
      );
    } else if (filterToRemove.type === 'dateFrom') {
      dispatch(
        setStudentDocumentsFilters({
          ...filters,
          from: undefined,
        }),
      );
    } else if (filterToRemove.type === 'dateTo') {
      dispatch(
        setStudentDocumentsFilters({
          ...filters,
          to: undefined,
        }),
      );
    }
  };

  const selectedFilters = getSelectedFilters();

  return <SelectedFilters filters={selectedFilters} onRemoveFilter={handleRemoveFilter} />;
};
